export const PHONE_COUNTRY_OPTIONS = [
  { value: "+52", label: "+52" },
  { value: "+1", label: "+1" },
  { value: "+34", label: "+34" },
  { value: "+57", label: "+57" },
  { value: "+56", label: "+56" },
  { value: "+55", label: "+55" },
  { value: "+51", label: "+51" },
  { value: "+49", label: "+49" },
  { value: "+81", label: "+81" },
];
